import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Resources } from './Resources';

const SUPPORTED = ['en', 'kk', 'ru', 'zh'] as const;
const stored = typeof window !== 'undefined' ? localStorage.getItem('language') : null;
const initialLng = stored && (SUPPORTED as readonly string[]).includes(stored) ? stored : 'en';

i18n.use(initReactI18next).init({
  lng: initialLng,
  fallbackLng: 'en',
  supportedLngs: [...SUPPORTED],
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: Resources,
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
  },
});

export default i18n;
